"use strict";

var _ = require("underscore");
var Reflux = require("reflux");
var moment = require("moment");
moment.locale("pt-br");

var ActivitiesListingActions = require("app/screens/Activity/actions/activities-listing-actions.js");
var ActivityDraft = require("app/util/browser/activity-draft");

const ORGANIZATION_LOCAL_STORE = "organizationActivitiesListFilters";
const PERSON_LOCAL_STORE = "personActivitiesListFilters";

var ActivitiesListingStore = Reflux.createStore({
  state: {
    activities: [],
    errorMsg: null,
    loading: true,
    loadingMore: false,
    failed: false,
    failedWithCustomError: false,
    failedWithClientSideError: false,
    retryButtonPressed: false,
    filters: {
      page: 1,
      per_page: 10
    },
    totalResults: 0,
    lastListCount: 0
  },
  init: function(){
    this.listenTo(ActivitiesListingActions.getActivities.loading, this.onGetActivitiesLoading);
    this.listenTo(ActivitiesListingActions.getActivities.completed, this.onGetActivitiesCompleted);
    this.listenTo(ActivitiesListingActions.getActivities.filtersChanged, this.onGetActivitiesFiltersChanged);
    this.listenTo(ActivitiesListingActions.getActivities.failed, this.onGetActivitiesFailed);
    this.listenTo(ActivitiesListingActions.getMoreActivities.loadingMore, this.onGetMoreActivitiesLoading);
    this.listenTo(ActivitiesListingActions.getMoreActivities.completed, this.onGetActivitiesCompleted);
    this.listenTo(ActivitiesListingActions.getMoreActivities.failed, this.onGetMoreActivitiesFailed);
    this.listenTo(ActivitiesListingActions.retryGetActivities.loading, this.onRetryGetActivitiesLoading);
    this.listenTo(ActivitiesListingActions.retryGetActivities.completed, this.onGetActivitiesCompleted);
    this.listenTo(ActivitiesListingActions.retryGetActivities.failed, this.onGetActivitiesFailed);
    this.listenTo(ActivitiesListingActions.finishActivity.completed, this.onFinishActivityCompleted);
    this.listenTo(ActivitiesListingActions.rescheduleActivity.completed, this.onRescheduleActivityCompleted);
    this.listenTo(ActivitiesListingActions.removeActivity.completed, this.onRemoveActivityCompleted);
    this.listenTo(ActivitiesListingActions.hideActivity, this.onHideActivity);
    this.listenTo(ActivitiesListingActions.editActivity, this.onEditActivity);
    this.listenTo(ActivitiesListingActions.cancelEdition, this.onCancelEdition);

    this.state = this.getDefaultData();
  },
  // this will be called by all listening components as they register their listeners
  getDefaultData: function() {
    if (window.location.href.includes("historico")) {
      this.state.filters = Object.assign({}, this.state.filters, this.retrieveSavedFilters());
    }
    return this.state;
  },
  retrieveSavedFilters: function() {
    let filter = "{}";

    if (window.location.href.includes("empresas")) {
      filter = localStorage.getItem(ORGANIZATION_LOCAL_STORE) || "{}";
    } else if (window.location.href.includes("pessoas")) {
      filter = localStorage.getItem(PERSON_LOCAL_STORE) || "{}";
    }

    return JSON.parse(filter);
  },
  persistFilter: function(filter) {
    let saveFilter, storeName;
    if (window.location.href.includes("empresas")) {
      saveFilter = _.pick(filter, "selectedHistoryOption", "append_related_deals", "append_related_people");
      storeName = ORGANIZATION_LOCAL_STORE;
    } else if (window.location.href.includes("pessoas")) {
      saveFilter = _.pick(filter, "selectedHistoryOption", "append_related_deals");
      storeName = PERSON_LOCAL_STORE;
    }

    localStorage.setItem(storeName, JSON.stringify(saveFilter));
  },
  onGetActivitiesLoading: function(){
    this.state.loading = true;
    this.trigger(this.state);
  },
  onGetMoreActivitiesLoading: function(){
    this.state.loadingMore = true;
    this.trigger(this.state);
  },
  defineActivityType: function(activity){
    _.each(activity.metrics, function(metric, i){
      if(metric.metric_type){
        activity.activityType = metric;
      }
    });
  },
  onGetActivitiesFiltersChanged: function(filters) {
    this.state.filters = filters;

    this.persistFilter(filters);

    this.trigger(this.state);
  },
  onGetActivitiesCompleted: function(activities, filters, total, append){
    this.state.loading = false;
    this.state.loadingMore = false;
    this.state.failed = false;
    this.state.retryButtonPressed = false;
    this.state.filters = filters || this.state.filters;
    this.state.lastListCount = activities.length;
    this.state.totalResults = total || 0;

    if(append){
      activities = this.removeDuplicatedActivities(this.state.activities, activities);
      activities = this.addActivityTypeToActivities(activities);
      this.state.activities.push.apply(this.state.activities, activities);
    } else {
      this.addActivityTypeToActivities(activities);
      this.state.activities = activities;
      this.state.filters.page = 1; // RESETS PAGINATION
      this.state.filters.offset = 0; // RESETS PAGINATION
    }

    this.trigger(this.state);
  },
  removeDuplicatedActivities: function(currentActivities, newActivities) {
    var currentActivitiesIds = _.pluck(currentActivities, "id");

    return _.filter(newActivities, function(activity) {
      return !_.contains(currentActivitiesIds, activity.id);
    });
  },
  addActivityTypeToActivities: function(activities) {
    return _.each(activities, function(activity, i){
      this.defineActivityType(activity);
    }.bind(this));
  },
  decrementPaginationOffset: function() {
    this.state.filters.offset -= 1;
  },
  onGetActivitiesFailed: function(error) {
    this.state.loading = false;
    this.state.loadingMore = false;
    this.state.failed = true;
    this.state.failedWithCustomError = !!error.customError;
    this.state.failedWithClientSideError = !!error.clientSideError;
    this.state.retryButtonPressed = false;
    this.state.activities = [];
    this.trigger(this.state);
  },
  onGetMoreActivitiesFailed: function(error) {
    this.state.loading = false;
    this.state.loadingMore = false;
    this.state.failed = true;
    this.state.failedWithCustomError = !!error.customError;
    this.state.failedWithClientSideError = !!error.clientSideError;
    this.state.retryButtonPressed = false;
    this.trigger(this.state);
  },
  onRetryGetActivitiesLoading: function() {
    this.state.retryButtonPressed = true;
    this.state.failed = false;

    this.trigger(this.state);
  },
  onFinishActivityCompleted: function(activityId, date, finished, data = {}){
    var activity = _.find(this.state.activities, function(a){return a.id==activityId;});
    if(activity){
      activity.finished_date = data.finished_date || date;
      activity.utc_finished_date = data.utc_finished_date;
      activity.finished_by = data.finished_by;
      this.trigger(this.state);
    }
  },
  onRescheduleActivityCompleted: function(activityId, dueDate, timezone){
    var activity = _.find(this.state.activities, function(a){return a.id==activityId;});
    activity.due_date = dueDate;
    activity.timezone = timezone;
    this.decrementPaginationOffset();
    this.trigger(this.state);
  },
  onRemoveActivityCompleted: function(activityId){
    var activities = _.filter(this.state.activities, function(a){
      return a.id!=activityId;
    });
    this.decrementPaginationOffset();
    this.state.activities = activities;
    this.trigger(this.state);
  },
  onHideActivity: function(activityId){
    var activities = _.filter(this.state.activities, function(a){
      return a.id!=activityId;
    });
    this.decrementPaginationOffset();
    this.state.activities = activities;
    this.trigger(this.state);
  },
  onPush: function(activity){
    this.defineActivityType(activity);
    this.state.activities.unshift(activity);
    this.state.totalResults = parseInt(this.state.totalResults) + 1;
    this.trigger(this.state);
  },
  onUpdate: function(updatedActivity){
    this.defineActivityType(updatedActivity);
    updatedActivity.editing = false;
    _.each(this.state.activities, function(activity, i){
      if(activity.id==updatedActivity.id){
        this.state.activities[i] = updatedActivity;
      }
    }.bind(this));
    this.trigger(this.state);
  },
  onEditActivity: function(activity, instanceKey){
    activity = _.find(this.state.activities, function(a){return a.id==activity.id;});
    activity.instanceKey = instanceKey;
    activity.editing = true;
    this.trigger(this.state);
  },
  onCancelEdition: function(activityId){
    ActivityDraft.removeActivity();
    var activity = _.find(this.state.activities, function(a){return a.id==activityId;});
    activity.editing = false;
    this.trigger(this.state);
  }
});

module.exports = ActivitiesListingStore;



// WEBPACK FOOTER //
// ./app/screens/Activity/stores/activities-listing-store.js